import React, { useContext, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { Redirect } from "react-router-dom"
import {
    Grid, Button, TextField, Typography, Box, Hidden, useTheme, useMediaQuery,
    Icon, InputAdornment, IconButton, Snackbar, Slide, CircularProgress
} from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Context } from "../../utils/context"
import useAuth from "../../hooks/modules/account/useAuth"
import useStyles from "../../hooks/useStyles"
import { Strings } from '../../assets/res/en'
import Footer from "../shell/Footer"
import RecoverPasswordModal from "../../modals/RecoverPasswordModal/RecoverPasswordModal"

export default function Login() {
    const { resetAuth } = useContext(Context)
    const [recoverpassword, setRecoverPassword] = useState(false)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const {
        authenticateUser,
        isUserAuthenticated,
        showPassword,
        setShowPassword,
        handleMouseDownPassword,
        response,
        handleToastClose,
        showToast,
        isAuthenticating
    } = useAuth()
    const classes = useStyles()
    const theme = useTheme()
    const direction = useMediaQuery(theme.breakpoints.up('sm')) === true ? "row" : "column"
    useEffect(() => {
        resetAuth()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <RecoverPasswordModal open={recoverpassword} onClose={() => setRecoverPassword(false)} />
            {
                isUserAuthenticated ?
                    <Redirect to="/" /> :
                    <Grid className={classes.loginContainer} container
                        direction={direction} justify="center" alignItems="center">
                        <Grid item sm={5} md={4} lg={3}>
                            <div className={classes.loginBox}>
                                <img src='img/login-img.jpg' alt='flexia' />
                            </div>
                        </Grid>
                        <Grid item sm={6} md={5} lg={4}>
                            <Grid className={classes.loginField}
                                container direction={direction} justify="center" alignItems="center">
                                <img src="img/logo.svg" alt="" height={48} />
                                <Grid container direction="row" justify="center" alignItems="center">
                                    <Typography variant="h5">{Strings.LOGIN}</Typography>
                                </Grid>
                                <Hidden lgUp>
                                    <Box m={1} />
                                </Hidden>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField type="email"
                                            label={Strings.USERNAME}
                                            fullWidth
                                            disabled={isAuthenticating}
                                            {...register("email", {
                                                required: { value: true, message: "Username is required" },
                                                pattern: { value: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/i, message: "Email is invalid" }
                                            })}
                                            error={!!errors.email}
                                        />
                                        {
                                            errors.email &&
                                            <span className={classes.invalid}>
                                                {errors.email.message}
                                            </span>
                                        }
                                    </Grid>
                                    <Box m={1} />
                                    <Grid item xs={12}>
                                        <TextField type={showPassword ? 'text' : 'password'}
                                            label={Strings.PASSWORD}
                                            fullWidth
                                            disabled={isAuthenticating}
                                            {...register("password", {
                                                required: { value: true, message: "Password is required" }
                                            })}
                                            error={!!errors.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            disableFocusRipple
                                                            disableRipple
                                                            disableTouchRipple
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            onMouseDown={handleMouseDownPassword}>
                                                            <Icon fontSize='small'>{`visibility${!!!showPassword && '_off'}`}</Icon>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                        {
                                            errors.password &&
                                            <span className={classes.invalid}>
                                                {errors.password.message}
                                            </span>
                                        }
                                    </Grid>
                                </Grid>
                                <Hidden lgUp>
                                    <Box m={1} />
                                </Hidden>
                                <Grid container>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        size="large"
                                        style={{ borderRadius: 25 }}
                                        className={classes.themedButton}
                                        onClick={handleSubmit(authenticateUser)}
                                        disabled={isAuthenticating}>
                                        <>
                                            {
                                                isAuthenticating &&
                                                <CircularProgress style={{ color: theme.palette.primary.contrastText, marginRight: theme.spacing(2) }} size={14} />
                                            }
                                            {Strings.LOGIN}
                                        </>
                                    </Button>
                                    <Button
                                        fullWidth
                                        variant="text"
                                        color="primary"
                                        disableFocusRipple
                                        disableRipple
                                        disableTouchRipple
                                        focusRipple
                                        disabled={isAuthenticating}
                                        onClick={() => setRecoverPassword(true)}
                                        style={{ textTransform: "none" }}>
                                        {Strings.FORGOT_PASSWORD}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            response.success === false &&
                            (
                                <Snackbar open={showToast} autoHideDuration={6000} onClose={handleToastClose}
                                    TransitionComponent={(props) => <Slide {...props} direction="up" />}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                                    <Alert severity="error" variant="filled" className={classes.alertBox} onClose={handleToastClose}>
                                        <AlertTitle>{response.errors.message}</AlertTitle>
                                        {response.errors.details}
                                    </Alert>
                                </Snackbar>
                            )
                        }
                        <Footer />
                    </Grid>
            }
        </>

    )
}